import React from "react";
import { Helmet } from "react-helmet";

export default function BlocoAnotacoes({ anotacao, setAnotacao }) {
  return (
    <div className="w-full space-y-4" style={{ fontFamily: "Comfortaa, cursive" }}>
      
      {/* Importa a fonte apenas neste componente */}
      <Helmet>
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="" />
        <link
          href="https://fonts.googleapis.com/css2?family=Comfortaa:wght@300..700&display=swap"
          rel="stylesheet"
        />
      </Helmet>

      <h2
        className="font-semibold text-gray-800"
        style={{
          fontFamily: "Comfortaa, cursive",
          fontSize: "16px",
        }}
      >
        Bloco de Anotações
      </h2>

      <textarea
        value={anotacao}
        onChange={(e) => setAnotacao(e.target.value)}
        placeholder="Escreva suas anotações aqui..."
        rows={8}
        className="w-full border border-gray-300 rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-blue-500 text-gray-800"
        style={{
          fontFamily: "Comfortaa, cursive",
          resize: "vertical",
        }}
      />

      <p className="text-sm text-gray-500" style={{ fontFamily: "Comfortaa, cursive" }}>
        As anotações serão salvas junto com os dados do cliente.
      </p>
    </div>
  );
}
